import React from "react"
import ModalImageCors from "../../../ModalImageCors"
import MarkdownWrapper from "../../../MarkdownWrapper"
import LocationPreview from "../../../LocationPreview"
import { File } from "lucide-react"
import { IconButton } from "@material-ui/core"
import { GetApp } from "@material-ui/icons"
import arquivoNomeFormatar from "../../../../utils/arquivoNomeFormatar"
import { adaptLocationMessage } from "./adaptLocationMessage"

/**
 * @param {import('../MessageItem').Message} message
 * @param {import("@material-ui/styles").ClassNameMap} classes
 * @param {boolean} isDeleted
 * @param {boolean} isMedia
 * @param {boolean} lVisualizacaoUnica
 * @param {boolean} lSticker
 * @param {boolean} isMobile
 */
export const checkMessageMedia = (message, classes, isDeleted, isMedia, lVisualizacaoUnica, lSticker, isMobile) => {
  if (!isMedia) return null

  const { mediaType, mediaUrl, fileName, body, dataJson } = message

  const renderVideo = () => (
    <div className={classes.messageMedia} style={{ marginBottom: 5 }}>
      <video className={classes.messageMedia} src={mediaUrl} controls preload="metadata" style={{ objectFit: "contain" }} />
    </div>
  )

  const renderAudio = () => (
    <audio controls preload="metadata" style={isMobile ? { width: "250px" } : {}}>
      <source src={mediaUrl} type="audio/ogg" />
    </audio>
  )

  const renderFile = () => (
    <div className={classes.downloadMedia}>
      <File style={{ margin: "0 10px" }} />
      <span>{arquivoNomeFormatar(mediaUrl, 44)}</span>
      <IconButton target="_blank" href={mediaUrl}>
        <GetApp />
      </IconButton>
    </div>
  )

  const renderLocation = () => {
    try {
      let imageLocation, linkLocation
      if (typeof body === "string" && body.includes("|")) {
        const [img, link] = body.split("|")
        imageLocation = img
        linkLocation = link
      } else if (dataJson) {
        const json = JSON.parse(dataJson)
        const adapted = adaptLocationMessage(json.message.locationMessage || json.message.liveLocationMessage)
        imageLocation = adapted.image
        linkLocation = adapted.link
      }
      return (
        <LocationPreview
          image={imageLocation}
          link={linkLocation}
          description={"Localização " + (message.fromMe ? "enviada" : "recebida")}
        />
      )
    } catch {
      return <MarkdownWrapper>*_Não foi possível carregar a localização_*</MarkdownWrapper>
    }
  }

  switch (mediaType) {
    case "image":
      return (
        <ModalImageCors
          imageUrl={mediaUrl}
          fileName={fileName}
          isViewOnce={lVisualizacaoUnica}
          isDeleted={isDeleted}
          sticker={lSticker}
          message={message}
          classes={classes}
        />
      )
    case "video":
      return renderVideo()
    case "audio":
      return renderAudio()
    case "locationMessage":
    case "liveLocationMessage":
      return renderLocation()
    default:
      return renderFile()
  }
}
